import { IGetAllObrasServicosControladosUseCase } from "../../../presentation/useCases/read/get_all_obras_servicos_controlados_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";

import { IObrasRepository } from "../../repositories/obras_repository";
import { GetAllObrasServicosControladosModel } from "../../models/obras_servicos_controlados";

/**
 * GetAllObrasServicosControladosUseCase
 */
export class GetAllObrasServicosControladosUseCase
  extends BasePaginatedUseCase<GetAllObrasServicosControladosModel>
  implements IGetAllObrasServicosControladosUseCase
{
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllObrasServicosControlados(idObra?: number, page?: number, rowsPerPage?: number): Promise<void> {
    const response = await this.repository.getAllObrasServicosControladosList({
      idObra,
      page,
      rowsPerPage,
    });

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
